<template>
  <div>
    <div
      class="canvas__container"
      :class="size"
    >
      <canvas
        id="canvas"
        :ref="'chart'"
        class="chart"
      />
    </div>

    <div v-if="getDatasets() && getDatasets().length > 1">
      <chart-legend
        :datasets="getDatasets()"
        @clicked="legendClicked"
      />
    </div>

    <div v-if="chartData && !!chartData.showAverageLine">
      <chart-legend
        :datasets="getDataForAverage()"
        :average-line="true"
        @clicked="averageClicked"
      />
    </div>
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import ChartLegend from './ChartLegend.vue'

  export default {
    name: 'BarChartHorizontal',
    components: { ChartLegend },
    props: {
      chartData: {
        type: Object,
        required: true
      },
      stacked: {
        type: Boolean,
        required: false,
        default: false
      },
      size: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        chartInstance: null
      }
    },
    mounted () {
      this.chartInstance = new Chart(this.$refs.chart, {
        type: 'horizontalBar',
        data: {
          xAxisSuffix: this.chartData.xAxisSuffix,
          labels: this.getLabels(),
          datasets: this.getDatasets()
        },
        options: {
          maintainAspectRatio: false,
          hover: { mode: null },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                return `${tooltipItem.xLabel} ${data.xAxisSuffix}`
              }
            },
            tooltips: {
              mode: 'index',
              intersect: true
            }
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              ticks: {
                callback: (value, index, values) => {
                  return `${value} ${this.chartData.xAxisSuffix}`
                }
              },
              gridLines: {
                display: false
              },
              stacked: this.stacked
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                callback: (value, index, values) => {
                  return `${value} ${this.chartData.yAxisSuffix}`
                }
              },
              gridLines: {
                display: false
              },
              stacked: this.stacked
            }]
          }
        },
        plugins: [{
          afterDatasetDraw: this.chartData.showAverageLine === true ? this.drawAverageLine : null
        }]
      })

      this.chartInstance.showAverage = true
    },
    methods: {
      getDataForAverage () {
        return [
          {
            backgroundColor: this.chartData.averageLineColor,
            label: this.chartData.averageLabel
          }
        ]
      },
      getLabels () {
        if (this.chartData.labels) {
          this.chartData.labels.forEach((el, i) => {
            this.chartData.labels[i] = unescape(el) // eslint-disable-line vue/no-mutating-props
          })
        }

        return this.chartData.labels || []
      },
      getDatasets () {
        return this.chartData.datasets || []
      },
      legendClicked (data) {
        this.chartInstance.data.datasets[data.setIndex].hidden = !this.chartInstance.data.datasets[data.setIndex].hidden
        this.chartInstance.update()
      },
      averageClicked () {
        this.chartInstance.showAverage = !this.chartInstance.showAverage
        this.chartInstance.update()
      },
      drawAverageLine (chart) {
        if (chart.showAverage === false) {
          return
        }

        const ctx = chart.controller.ctx
        let element = 0

        for (const datasetIndex in chart.config.data.datasets) {
          const meta = chart.getDatasetMeta(datasetIndex)
          for (const dataIndex in meta.data) {
            element = meta.data[dataIndex]
            if (element.hidden === true) {
              continue
            }
          }

          const avarageValue = this.chartData.averageValue
          const pos = element._xScale.getPixelForValue(avarageValue)

          ctx.beginPath()
          ctx.moveTo(pos, element._xScale.chart.chartArea.top)
          ctx.lineTo(pos, element._xScale.chart.chartArea.bottom)
          ctx.strokeStyle = this.chartData.averageLineColor
          ctx.lineWidth = 2
          ctx.stroke()
        }
      }

    }
  }
</script>

<style lang="scss" scoped>
  .canvas__container {
    canvas {
      height: 100%;
    }

    &.small {
      height: rem(200px);
    }

    &.normal {
      height: rem(300px);
    }

    &.large {
      height: rem(600px);
    }
  }
</style>
